import React, { Component } from "react";
import { Api } from "../app-controller";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { Panel, PanelBody } from "../components/panel/panel.jsx";

class ReporteSustancias extends Component {
  initialState = {
    options_importadores: [],
    option_productos: [],
    option_empaque: [],
    option_paises: Api.loadCatalogue("countries"),

    nivelUsuario: localStorage.nivel_actual,

    reporte: {
      importador_id: "",
      cantidad: "",
      producto_id: "",
      nombre_comercial: "",
      tipo_producto_id: "",
      empaque_id: "",
      numero_factura: "",
      numero_permiso: "",
      nombre_aduana: "",
      numero_lote: "",
      empaque_nombre: "",
      pais_despacho_id: "",
      fecha_fabricacion: new Date().toISOString().slice(0, 10),
      vencimiento_lote: new Date().toISOString().slice(0, 10),
      rel_id: "",
      ingreso_aduana: new Date().toISOString().slice(0, 10),
      ingreso_bodega: new Date().toISOString().slice(0, 10),
    },
  };

  state = this.initialState;

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.handleChangeReporte = this.handleChangeReporte.bind(this);

    this.handlePais = this.handlePais.bind(this);
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    Api.loading(true);
    let actividades = [18,19,20];//actividades de importador
    Api.fetch(
      "app/getEstablecimientosRepRegPorActividad",
      { actividades },
      "POST"
    ).then((data) => {
      if (data) {
        this.setState({
          options_importadores: data,
        });
      }
      Api.loading(false);
    });
  }

  handlePais(e) {
    let pais = this.state.option_paises.find(
      (d) => d.descripcion === e.target.value
    );
    let lada = "+";
    if (pais.lada !== null) {
      lada = "+" + pais.lada;
    }

    this.setState({ pais: e.target.value, lada: lada });

    this.handleLatLong(e.target.value);
  }

  handleChangeReporte(e) {
    let reporte = { ...this.state.reporte };
    let reset = { ...this.initialState.reporte };

    reporte[e.target.name] = e.target.value;

    switch (e.target.name) {
      case "importador_id":
        if (reporte["producto_id"] !== "") {
          reporte = reset;
          reporte[e.target.name] = e.target.value;
        }
        Api.fetch(
          "app/getProductosSustanciaEstablecimiento?establecimiento_id=" +
            e.target.value
        ).then((data) => {
          if (data) {
            this.setState({
              option_productos: data,
            });
          }
        });
        break;
      case "producto_id":
        let producto = this.state.option_productos.find(
          (d) => d.id.toString() === e.target.value
        );

        if (producto.tipo_producto_id === "4") {
          //no tiene empaque si no presentacion
          Api.fetch("app/getPresentacionProducto?id=" + e.target.value).then(
            (data) => {
              if (data) {
                this.setState({
                  option_empaque: data,
                });
              }
            }
          );
        } else {
          Api.fetch("app/getEmpaqueProducto?id=" + e.target.value).then(
            (data) => {
              if (data) {
                this.setState({
                  option_empaque: data,
                });
              }
            }
          );
        }

        reporte["nombre_comercial"] = producto.nombre_comercial;
        reporte["tipo_producto_id"] = producto.tipo_producto_id;

        break;
      case "rel_id":
        let empaque = this.state.option_empaque.find(
          (d) => d.rel_id.toString() === e.target.value
        );

        if (reporte["tipo_producto_id"] !== "4") {
          reporte["empaque_id"] = empaque.empaque_id;
          reporte["empaque_nombre"] =
            empaque.empaque_name.toUpperCase() +
            " (" +
            empaque.presentacion_cantidad +
            empaque.presentacion_unidad_medida_name +
            ")";
        } else {
          reporte["empaque_nombre"] =
            empaque.presentacion_cantidad +
            empaque.presentacion_unidad_medida_name;
        }

        break;
      case "nombre_aduana":
        reporte[e.target.name] = e.target.value.toUpperCase();
        break;
      case "numero_lote":
        reporte[e.target.name] = e.target.value.toUpperCase();
        break;
      default:
        break;
    }

    this.setState({ reporte: reporte });
  }

  handleSubmit(e) {
    e.preventDefault();
    let reporte = this.state.reporte;
    let valido = 1;

    for (let i in reporte) {
      if (reporte[i] === "") {
        Swal.fire({
          title: "Atencion",
          icon: "warning",
          text: "Favor de revisar que el formulario este completo.",
        });
        valido = 0;
        return false;
      }
    }

    if (valido) {
      Swal.fire({
        title: "¿Seguro que desea reportar el importe? ",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/reportarSustanciaImporte",
            {
              reporte: reporte,
            },
            "POST"
          ).then((data) => {
            Api.loading(false);
            Swal.fire({
              title: "Se reportó con éxito",
              icon: "success",
            }).then(() => {
              window.location.href = "/reportes-importacion";
            });
          });
        }
      });
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/reportar-importacion">Reportes</Link>
          </li>
          <li className="breadcrumb-item">Generar reporte importación</li>
        </ol>
        <h1 className="page-header">
          Generar reporte importación medicamentos
        </h1>

        <div className="row" onSubmit={this.handleSubmit}>
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form id="frmRep" style={{ margin: "2.5%" }}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Importador: <span className="text-danger"> *</span>
                        </label>
                        <select
                          name="importador_id"
                          id="importador_id"
                          onChange={this.handleChangeReporte}
                          value={this.state.reporte.importador_id}
                          className="form-control"
                          required
                        >
                          <option value="">Seleccione</option>
                          {this.state.options_importadores.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.razon_social} [
                              {option.folio_establecimiento}]
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>
                          Número de lote:{" "}
                          <span className="text-danger"> *</span>{" "}
                        </label>
                        <input
                          type="text"
                          value={this.state.reporte.numero_lote}
                          name="numero_lote"
                          maxLength={30}
                          onChange={this.handleChangeReporte}
                          className="form-control"
                          id="numero_lote"
                          title="Número de lote"
                          placeholder="Ingresa número de lote"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label>
                          Cantidad: <span className="text-danger"> *</span>{" "}
                        </label>
                        <input
                          type="number"
                          value={this.state.reporte.cantidad}
                          name="cantidad"
                          maxLength={7}
                          onChange={this.handleChangeReporte}
                          className="form-control"
                          id="cantidad"
                          title="Cantidad importada"
                          min={1}
                          placeholder="##"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Producto: <span className="text-danger"> *</span>
                        </label>
                        <select
                          name="producto_id"
                          id="producto_id"
                          onChange={this.handleChangeReporte}
                          value={this.state.reporte.producto_id}
                          className="form-control"
                          title="Seleccione"
                          required
                        >
                          <option value="">Seleccione</option>
                          {this.state.option_productos.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.nombre_comercial}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className={"col-lg-6"}>
                      <div className="form-group">
                        <label>
                          Empaque: <span className="text-danger"> *</span>
                        </label>
                        <select
                          name="rel_id"
                          id="rel_id"
                          onChange={this.handleChangeReporte}
                          value={this.state.reporte.rel_id}
                          className="form-control"
                          title="Seleccione"
                          required
                        >
                          {this.state.reporte.tipo_producto_id === "4" ? (
                            <>
                              <option value="">Seleccione</option>
                              {this.state.option_empaque.map((option) => (
                                <option key={option.id} value={option.rel_id}>
                                  ({option.presentacion_cantidad}{" "}
                                  {option.presentacion_unidad_medida_name})
                                </option>
                              ))}
                            </>
                          ) : (
                            <>
                              <option value="">Seleccione</option>
                              {this.state.option_empaque.map((option) => (
                                <option key={option.id} value={option.rel_id}>
                                  {option.empaque_name} (
                                  {option.presentacion_cantidad}{" "}
                                  {option.presentacion_unidad_medida_name})
                                </option>
                              ))}
                            </>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Número de factura:{" "}
                          <span className="text-danger"> *</span>{" "}
                        </label>
                        <input
                          type="text"
                          value={this.state.reporte.numero_factura}
                          name="numero_factura"
                          maxLength={30}
                          onChange={this.handleChangeReporte}
                          className="form-control"
                          id="numero_factura"
                          title="Número de factura"
                          placeholder="Ingresa número de factura"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Número de permiso:{" "}
                          <span className="text-danger"> *</span>{" "}
                        </label>
                        <input
                          type="text"
                          value={this.state.reporte.numero_permiso}
                          name="numero_permiso"
                          maxLength={30}
                          onChange={this.handleChangeReporte}
                          className="form-control"
                          id="numero_permiso"
                          title="Número permiso"
                          placeholder="Ingresa número de permiso"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Nombre de aduana:{" "}
                          <span className="text-danger"> *</span>{" "}
                        </label>
                        <input
                          type="text"
                          value={this.state.reporte.nombre_aduana}
                          name="nombre_aduana"
                          maxLength={150}
                          onChange={this.handleChangeReporte}
                          className="form-control"
                          id="nombre_aduana"
                          title="Nombre de aduana"
                          placeholder="Ingrese el nombre de aduana"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Ingreso aduana:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="date"
                          name="ingreso_aduana"
                          onChange={this.handleChangeReporte}
                          id="ingreso_aduana"
                          value={this.state.reporte.ingreso_aduana}
                          className="form-control"
                          placeholder="Seleccione"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          País despacho: <span className="text-danger"> *</span>
                        </label>
                        <select
                          name="pais_despacho_id"
                          id="pais_despacho_id"
                          onChange={this.handleChangeReporte}
                          value={this.state.reporte.pais_despacho_id}
                          className="form-control"
                          title="Seleccione"
                          required
                        >
                          <option value="">Seleccione</option>
                          {this.state.option_paises.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.descripcion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Ingreso bodega:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="date"
                          name="ingreso_bodega"
                          onChange={this.handleChangeReporte}
                          id="ingreso_bodega"
                          value={this.state.reporte.ingreso_bodega}
                          className="form-control"
                          placeholder="Seleccione"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Fecha fabricación:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="date"
                          name="fecha_fabricacion"
                          onChange={this.handleChangeReporte}
                          id="fecha_fabricacion"
                          value={this.state.reporte.fecha_fabricacion}
                          className="form-control"
                          placeholder="Seleccione"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label>
                          Vencimiento lote:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="date"
                          name="vencimiento_lote"
                          onChange={this.handleChangeReporte}
                          id="vencimiento_lote"
                          value={this.state.reporte.vencimiento_lote}
                          className="form-control"
                          placeholder="Seleccione"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="col-lg-2 float-right">
                    <button
                      type="submit"
                      className="btn btn-success btn-block"
                      onClick={this.handleSubmit}
                    >
                      Reportar
                    </button>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default ReporteSustancias;
